import React from 'react';

const ALL_RESULTS_SKELETON_LENGTH = 12;

export const AllResultsMobileSkeleton = () => {
  return (
    <div className="flex flex-col gap-3 md:hidden">
      {[...Array(ALL_RESULTS_SKELETON_LENGTH)].map((_, i) => (
        <div key={`top-results-mobile-${i}-skeleton`}>
          <div className="h-12 w-full animate-pulse rounded-md bg-gradient-to-br from-gray300 to-gray200 [&_*]:opacity-0" />
        </div>
      ))}
    </div>
  );
};
